import { render, staticRenderFns } from "./CompanySubscribers.vue?vue&type=template&id=b306539a&scoped=true&"
import script from "./CompanySubscribers.vue?vue&type=script&lang=js&"
export * from "./CompanySubscribers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b306539a",
  null
  
)

export default component.exports